<template>
  <div class="stores mrx-5 mlx-5">
    <v-row style="box-shadow: 0 3px 1px -2px rgba(0, 0, 0, .2), 0 2px 2px 0 rgba(0, 0, 0, .14), 0 1px 5px 0 rgba(0, 0, 0, .12) !important;
" no-gutters class="mt-5 mb-5 mrx-5 mlx-5">
      <v-col cols="4" class="list">
        <div class="list-store">
          <div class="content-list-store">
            <div class="list_store">
              <div class="title-sub-categories-innerStore">
                <span style="color: white;font-size: 15px; font-weight: bold">{{oracle.translate('لیست فروشگاه ها')}}</span>
              </div>
              <div class="box-list-store" v-ripple role="button" @click="showinfo(item.shop_id)"
                   v-for="(item, index) in AllMapData"
                   :key="index">
                <div class="item-list-store">
                  <div class="img-list-store">
                    <img alt="" :src="item.shop_cover" />
                  </div>
                  <span class="font-weight-bold" style="font-size: 15px">{{ oracle.shop_name(item) }}</span>
                </div>
                <div>
                  <div :class="item.shop_type == 0 ? '' : 'buy-pre'">
                                    <span>{{
                                        oracle.translate(
                                            item.shop_type == 0 ? '' : item.shop_type == 1 ? 'خرید حضوری'
                                                : item.shop_type == 2 ? 'سیار' : 'به زودی'
                                        )
                                      }}</span>
                  </div>
                  <div class="shop_css" v-if="item.shop_delivery">
                    <p class="mrx-2">{{oracle.translate('پیک')}}</p>
                    <v-icon class="mrx-1 mlx-2">check</v-icon>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </v-col>
      <v-col cols="8">
        <div id="mapOrder" class="map" v-if="IsLoadMap">
          <mapir :apiKey="MapirApiKey" :center="center" v-if="IsLoadMap">
            <mapAttributionControl/>
            <mapNavigationControl position="top-right"/>
            <mapGeolocateControl position="top-left"/>
            <mapScaleControl position="top-left"/>
            <mapMarker
                v-for="(item, index) in coordinates"
                :coordinates="item.lng"
                :key="index"
                :draggable="false">
              <img alt="" :src="item.marker"  slot="marker" class="mapMarker"/>
              <mapPopup class="p-2">
                <div style="color: #7dc353; font-weight: bold;" class="mt-2 mb-2 mrx-3 mlx-3" v-ripple role="button"
                     @click="showinfo(item.shop_id)">{{ item.title }}
                </div>
              </mapPopup>
            </mapMarker>
          </mapir>
        </div>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import {
  mapir,
  mapMarker,
  mapAttributionControl,
  mapNavigationControl,
  mapGeolocateControl,
  mapScaleControl,
  mapPopup,
} from "mapir-vue";
import oracle from "@/oracle";

export default {
  name: "stores",
  components: {
    mapir,
    mapNavigationControl,
    mapMarker,
    mapAttributionControl,
    mapGeolocateControl,
    mapScaleControl,
    mapPopup,
  },
  data: () => ({
    AllMapData: null,
    showaddres: false,
    IsLoadMap: false,
    center: [51.420296, 35.732379],
    coordinates: [],
    oracle: oracle,
    MapirApiKey: "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6Ijc3OTZjOTI0MGJlNzA2ODFhZjkwOGZmNjJkMmNmZDZjZGEyZGZiYjg5ZTk1YzYwYmI5ODFkZDA1ZGM4YWUzMDdlZmE1YmEwMGEwMDUyNTcxIn0.eyJhdWQiOiIxMjg0MyIsImp0aSI6Ijc3OTZjOTI0MGJlNzA2ODFhZjkwOGZmNjJkMmNmZDZjZGEyZGZiYjg5ZTk1YzYwYmI5ODFkZDA1ZGM4YWUzMDdlZmE1YmEwMGEwMDUyNTcxIiwiaWF0IjoxNjEzNTYxNDIwLCJuYmYiOjE2MTM1NjE0MjAsImV4cCI6MTYxNjA2NzAyMCwic3ViIjoiIiwic2NvcGVzIjpbImJhc2ljIl19.PGE1y2V5xX6kKL5qG08k21qZ5fzge8RD_DaBkMuQW7vOdHFzwnM1rGnuiCQ9dPw7irbURXkNT5SdLRWGAjDzahK4dH6Y4QT3DScuEm05ZSozzgWaBMNDdQmBF8-Hi01StkZqBP4wrZMLO1PpxgEe9zjbZRSY_yfFr4usUuSyYeYxT3DPo4GrDz7WFWzpl73mKl30ka_THDdPj0d3f_cnwAOsZuETS3hzeb_duplYGIbwJAFZ4OsTlVKYnxPp8lHyboa3rwP0I3inQB2o-lzZFJjsEGZYhVKZeayUR_3t4DthI52NJvJDvTYb-yAs5zXcm6vWDnWEc0Kd9pp45qPcAQ"
  }),
  created() {
    this.map = null;
  },
  methods: {
    onMapLoaded(event) {
      this.map = event.map;
      this.$store.map = event.map;
    },
    onClick(e) {
    },
    showinfo(id) {
      this.$router.push({name: 'innerStore', query: {id: id}})
    },
    closeshowinfo() {
      this.showaddres = false;
    },
    GetCatMap(response) {
      this.IsLoadMap = false
      this.AllMapData = response.data;
      let Array = [];
      for (let i = 0; i < this.AllMapData.length; i++) {
        Array.push({
          id: i,
          shop_id: this.AllMapData[i].shop_id,
          title: this.oracle.shop_name(this.AllMapData[i]),
          lng: [this.AllMapData[i].shop_longitude, this.AllMapData[i].shop_latitude],
          marker: this.AllMapData[i].shop_icon,
        })
      }
      this.coordinates = Array;
      this.IsLoadMap = true;
    }
  },
  mounted() {
    oracle.axios(
        "shop/getList",
        {"limit_by": 500, "offset_by": 0, "order_by": "priority"},
        this.GetCatMap
    );
  }
};
</script>
<style>
.stores .content-list-store {
  height: calc(100vh);
  overflow: hidden;
  background: #fff;
  display: flex;
  position: relative;
  border: 2px solid #7ec352;
  border-radius: 3px;
}

.stores .list_store {
  height: 100%;
  overflow: auto;
  width: 100%;
}

.stores .store-info {
  height: calc(100vh - 190px);
  position: absolute;
  top: 100%;
  height: 100%;
  left: 0;
  transition: 0.3s;
  overflow: auto;
  background: #fff;
  padding: 15px 10px;
}

.stores .active {
  top: 0;
}

.stores .list-store {
  width: 100%;
  height: 100%;
  display: inline-block;
  z-index: 1;
}

.stores .search-listStore {
  padding: 25px 10px;
  background-color: #7dc353;
  color: #f2f2f2;
  font-size: 12px;
  display: flex;
  justify-content: space-between;
}

.stores .search-listStore span {
  font-size: 12px;
  color: #fff;
}

.stores .searchStore {
  display: flex;
  width: 80%;
}

.stores .searchStore .v-text-field.v-text-field--solo .v-input__control {
  min-height: 30px;
  box-shadow: none;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.stores .searchStore label {
  font-size: 10px;
}

.stores .searchStore button {
  height: 32px !important;
  box-shadow: none !important;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.stores .searchStore button .v-icon {
  color: #333 !important;
  cursor: pointer;
}

.stores .list {
  padding: 0;
  height: 100%;
}

.stores .mapstore {
  padding: 0;
}

.stores .title-sub-categories-innerStore {
   color: #fff;
   line-height: 20px;
   padding: 10px 5px;
   font-size: 15px;
   background-color: #7ec352;
 }

.stores .item-list-store {
  display: flex;
  cursor: pointer;
}

.stores .item-list-store span {
  font-size: 12px;
  color: #333;
  margin-right: 10px;
  margin-left: 10px;
  align-items: center;
  display: flex;
}

.stores .img-list-store {
  width: 35px;
  height: 35px;
}

.stores .img-list-store img {
  width: 100%;
  height: 100%;
}

.stores .title-store-info {
  display: flex;
  justify-content: flex-end;
  padding: 10px 15px;
}

.stores .title-store-info .v-icon {
  font-size: 20px !important;
  color: #333;
  cursor: pointer;
}

.stores .store-info h1 {
  font-size: 14px;
  color: #333;
}

.stores .info-stores {
  margin-top: 25px;
  border-bottom: 1px solid #ccc;
  padding-bottom: 5px;
  margin-bottom: 5px;
}

.stores .info-stores h6 {
  color: #999;
  font-size: 12px;
  padding: 10px 15px;
}

.stores .innerStore-info span,
.stores .innerStore-info p {
  font-size: 12px;
  margin-top: 10px;

}

.stores .innerStore-info {
  position: absolute;
  transform: translateY(100%);
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s;
  background: #fff;
}

.stores .innerStore-info.active {
  transform: translateY(0);
  opacity: 1;
  visibility: visible;
}

.stores .innerStore-info h1 {
  font-size: 15px;
  padding: 10px 20px;
}

.stores .store-info p {
  margin-bottom: 0;
}

.stores .box-list-store {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 15px;
}

.stores .buy-pre {
  background-color: #7dc353;
  border: 2px solid #7dc353;
  border-radius: 25px;
  padding: 5px 10px;
  display: flex;
}

.stores .buy-pre2 {
  background-color: #2ab0f7;
  border: 2px solid #2ab0f7;
  border-radius: 25px;
  padding: 5px 10px;
  display: flex;
}

.stores .buy-pre span {
  color: #fff;
  font-size: 10px;
}

.stores .buy-pre2 span {
  color: #fff;
  font-size: 10px;
}

.stores .map {
  width: 100%;
  height: 100%;
}

.stores .mapMarker {
  /* transform: translate(-40%, 0%) translate(631px, -232px) rotateX(0deg)
    rotateZ(0deg) !important; */
  width: 35px;
  height: 45px;
}

.stores .shop_css {
  background-color: #2ab0f7;
  width: auto;
  height: 25px;
  border-radius: 30px;
  display: flex !important;
  color: white;
  font-size: 10px;
  padding: 3px !important;
  margin: 0 !important;
  align-content: center;
  align-items: center;
  justify-content: center;
  box-shadow: 0 3px 1px -2px rgba(0, 0, 0, .2), 0 2px 2px 0 rgba(0, 0, 0, .14), 0 1px 5px 0 rgba(0, 0, 0, .12) !important;
}

.stores .shop_css .v-icon {
  font-size: 12px;
  color: white;
}

.stores .shop_css p {
  text-align: center !important;
  margin-bottom: 0 !important;
}

.stores .mapboxgl-popup-close-button {
  padding: 4px 6px 4px 4px;
}
</style>
